import {InjectionToken} from '@angular/core';

export const TISA_BUCKET_URL = new InjectionToken<string>('Provides bucket url.');
